export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/noah-rosenfield-bd0443bdd9f69bf7844cdf636c24c699.jpg";